export class UsuarioAdminRequest {
  domain: String;
  password: String;    
  constructor(){
    this.domain="";    
    this.password="";
  }
}
